import { Component } from '@theme/component';

/**
 * Before/after comparison slider. Extends Component (not a bare custom
 * element or inline <script>) so it re-initializes correctly whenever the
 * Section Rendering API morphs this block, and its `on:input`/`on:change`
 * handlers keep working after the theme editor re-renders the section.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} stage
 * @property {HTMLInputElement} range
 *
 * @extends {Component<Refs>}
 */
export class DrappComparisonSlider extends Component {
  requiredRefs = ['stage', 'range'];

  connectedCallback() {
    super.connectedCallback();
    this.sync();
  }

  /**
   * Writes the current range value onto the stage's --pos custom property.
   * Bound declaratively via on:input / on:change on the range ref.
   */
  sync() {
    this.refs.stage.style.setProperty('--pos', `${this.refs.range.value}%`);
  }
}

if (!customElements.get('drapp-comparison-slider-component')) {
  customElements.define('drapp-comparison-slider-component', DrappComparisonSlider);
}
